import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const m = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: i, color: o, withColor: c, removeClassName: t, disableSSR: d, style: n, ...p }) => {
  const x = n ? { ...m, ...n } : m;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-kuaijiejiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (i ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (i ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-å¿«æ·äº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: c ? r(o, 0, "#262933") : "#262933",
        datafollowfill: c ? r(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M16 5.7C10.313 5.7 5.7 10.312 5.7 16c0 5.689 4.612 10.3 10.3 10.3a.9.9 0 0 1 0 1.8C9.318 28.1 3.9 22.683 3.9 16 3.9 9.318 9.319 3.9 16 3.9c6.683 0 12.1 5.418 12.1 12.1a.9.9 0 0 1-1.8 0c0-5.688-4.611-10.3-10.3-10.3Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M25.852 19.096a.9.9 0 1 0-1.33 1.213l.639.7H20a.9.9 0 0 0 0 1.8h7.2a.9.9 0 0 0 .665-1.506l-2.012-2.207Zm-4.538 8.679a.9.9 0 1 0 1.339-1.203l-.634-.705h5.15a.9.9 0 0 0 0-1.8h-7.17a.9.9 0 0 0-.668 1.502l1.983 2.206Zm-3.95-16.814a.9.9 0 1 0-1.546-.922l-3.09 5.182a.9.9 0 0 0 .772 1.36h4.015l-2.955 4.196a.9.9 0 1 0 1.471 1.037l3.955-5.614a.9.9 0 0 0-.736-1.418h-4.165l2.279-3.82Z"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
